import createPalette from '@mui/material/styles/createPalette';
import createTheme from '@mui/material/styles/createTheme';
import { palette } from './palette';

const defaultMUITheme = createTheme();

declare module '@mui/material/styles' {
  interface Palette {
    danger: Palette['primary'];
  }
  interface PaletteOptions {
    danger: PaletteOptions['primary'];
  }
}

const sharedPalette = {
  primary: { main: palette.primary[400], light: palette.primary[50] },
  secondary: defaultMUITheme.palette.augmentColor({
    color: { main: palette.secondary[400] },
    name: 'secondary',
  }),
  error: { main: palette.error[400], light: palette.error[50], backing: '#952A1F0F' },
  info: {
    main: palette.info[400],
    light: palette.info[50],
  },
  success: {
    main: palette.success[400],
    light: palette.success[50],
    dark: palette.success[800],
  },
  warning: {
    dark: palette.warning[800],
    main: palette.warning[400],
    light: palette.warning[50],
  },
  danger: defaultMUITheme.palette.augmentColor({
    color: { main: palette.danger[400] },
    name: 'danger',
  }),
  text: {
    primary: palette.text[400],
    secondary: palette.text[200],
    disabled: palette.text[100],
  },
};

export const facilityLightPalette = createPalette({
  ...sharedPalette,
  background: {
    default: '#F9FAFB',
  },
});

export const lightPalette = createPalette({
  ...sharedPalette,
});
